module.exports = __webpack_public_path__ + "SPACEC6P.3823b19fe3cbf045e417.woff";


//////////////////
// WEBPACK FOOTER
// /Users/Guest/Desktop/Space-Janitor/src/assets/fonts/SPACEC6P.woff
// module id = ../../../../../src/assets/fonts/SPACEC6P.woff
// module chunks = main